window.getPref = function (key, defaultValue) {
    if (window.SESSION) {
        return window.SESSION.getPref(key, defaultValue);
    }
};

window.cb = function () {
    return window.SESSION.currentBuffer;
};
window.cbc = function () {
    var b = window.cb();
    if (b) {
        return b.connection;
    }
};
window.lcm = function () {
    return window.SESSIONVIEW.lastClickedMessage;
};
window.cbv = function () {
    return window.SESSIONVIEW.mainArea.current;
};

window.ct = function () {
    return window.SESSIONVIEW.mainArea.currentThread.model;
};
window.ctv = function () {
    return window.SESSIONVIEW.mainArea.currentThread;
};



//////////////////
// WEBPACK FOOTER
// ./app/src/lib/consolehelpers.js
// module id = MfRu
// module chunks = 1